import style from './Adote.module.scss';

const Adote = () => {
  return (
    <section className={style.container}>
      
      <h1 className={style.titulo}>Adote um animal</h1>
    </section>
  )
}

export default Adote;